import React from "react";
import { useTranslation } from "react-i18next";
import { ActionsTab } from "./ActionsTab";

export const StrategyBoard = () => {
  const { t } = useTranslation();

  return (
    <div className="h-full">
      <div className="border-b p-6 pb-4 text-2xl font-bold text-foreground">
        <h1> {t("strategyBoard.title")} </h1>
      </div>
      <ActionsTab />
    </div>
  );
};
